module.exports = __webpack_public_path__ + "static/media/blackDisabledTicketIcon.b684dbc0.svg";